export default function ServiceDigitalTwin({ size = 96 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 96 96" fill="none" aria-hidden="true">
      <rect x="14" y="22" width="32" height="40" stroke="currentColor" strokeWidth="1.25" />
      <path d="M22 30 H38 M22 38 H34 M22 46 H30" stroke="currentColor" strokeWidth="1.25" />
      <rect x="50" y="34" width="32" height="40" stroke="#54B53C" strokeWidth="1.25" strokeDasharray="2 3" />
      <path d="M58 42 H74 M58 50 H70 M58 58 H66" stroke="currentColor" strokeWidth="1.25" />
      <path d="M46 42 L50 42 M46 54 L50 54" stroke="currentColor" strokeWidth="1.25" />
    </svg>
  );
}
